import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined

const EditGeneralSetup = () => {
    const { id } = useParams(); // Get the setup ID from the URL
    const navigate = useNavigate();

    // State for holding the general setup data
    const [generalSetup, setGeneralSetup] = useState({
        code: '',
        multiCurrency: false,
        removeCurrencySymbolInReport: false,
        multiLocation: false,
        bookStartDate: '',
        whatsappUrl: '',
        whatsappUsername: '',
        whatsappPassword: '',
        senderEmail: '',
        senderPassword: '',
        displayName: '',
        smtpServer: '',
        smtpMailPort: 587,
        smtpTimeout: 30,
        sslRequired: false,
    });

    // Fetch general setup details on component mount
    useEffect(() => {
        fetch(`${BASE_URL}generalsetup/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    setGeneralSetup(data.data);
                }
            })
            .catch((error) => console.error('Error fetching general setup details:', error));
    }, [id]);

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        fetch(`${BASE_URL}generalsetup/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(generalSetup),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                if (data.status === 'success') {
                    alert('General Setup updated successfully!');
                    navigate('/EditGeneralSetup/1'); // Assuming the route to list is `/GeneralSetupList`
                } else {
                    alert('Error updating general setup. Please try again.');
                }
            })
            .catch((error) => {
                console.error('Error updating general setup:', error);
                alert('Error updating general setup. Please check the console for more details.');
            });
    };

    // Handle input change for all fields
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setGeneralSetup({
            ...generalSetup,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit General Setup</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit General Setup Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header"></div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="code" className="form-label">Code</label>
                                        <input
                                            type="text"
                                            id="code"
                                            name="code"
                                            className="form-control"
                                            value={generalSetup.code}
                                            onChange={handleChange}
                                            placeholder="Enter Code"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="multiCurrency" className="form-label">Multi Currency</label>
                                        <input
                                            type="checkbox"
                                            id="multiCurrency"
                                            name="multiCurrency"
                                            checked={generalSetup.multiCurrency}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="removeCurrencySymbolInReport" className="form-label">Remove Currency Symbol In Report</label>
                                        <input
                                            type="checkbox"
                                            id="removeCurrencySymbolInReport"
                                            name="removeCurrencySymbolInReport"
                                            checked={generalSetup.removeCurrencySymbolInReport}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="multiLocation" className="form-label">Multi Location</label>
                                        <input
                                            type="checkbox"
                                            id="multiLocation"
                                            name="multiLocation"
                                            checked={generalSetup.multiLocation}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="bookStartDate" className="form-label">Book Start Date</label>
                                        <input
                                            type="date"
                                            id="bookStartDate"
                                            name="bookStartDate"
                                            className="form-control"
                                            value={generalSetup.bookStartDate}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="whatsappUrl" className="form-label">Whatsapp URL</label>
                                        <input
                                            type="text"
                                            id="whatsappUrl"
                                            name="whatsappUrl"
                                            className="form-control"
                                            value={generalSetup.whatsappUrl}
                                            onChange={handleChange}
                                            placeholder="Enter WhatsApp URL"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="whatsappUsername" className="form-label">Whatsapp Username</label>
                                        <input
                                            type="text"
                                            id="whatsappUsername"
                                            name="whatsappUsername"
                                            className="form-control"
                                            value={generalSetup.whatsappUsername}
                                            onChange={handleChange}
                                            placeholder="Enter WhatsApp Username"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="whatsappPassword" className="form-label">Whatsapp Password</label>
                                        <input
                                            type="password"
                                            id="whatsappPassword"
                                            name="whatsappPassword"
                                            className="form-control"
                                            value={generalSetup.whatsappPassword}
                                            onChange={handleChange}
                                            placeholder="Enter WhatsApp Password"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="senderEmail" className="form-label">Sender Email</label>
                                        <input
                                            type="email"
                                            id="senderEmail"
                                            name="senderEmail"
                                            className="form-control"
                                            value={generalSetup.senderEmail}
                                            onChange={handleChange}
                                            placeholder="Enter Sender Email"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="senderPassword" className="form-label">Sender Password</label>
                                        <input
                                            type="password"
                                            id="senderPassword"
                                            name="senderPassword"
                                            className="form-control"
                                            value={generalSetup.senderPassword}
                                            onChange={handleChange}
                                            placeholder="Enter Sender Password"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="displayName" className="form-label">Display Name</label>
                                        <input
                                            type="text"
                                            id="displayName"
                                            name="displayName"
                                            className="form-control"
                                            value={generalSetup.displayName}
                                            onChange={handleChange}
                                            placeholder="Enter Display Name"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="smtpServer" className="form-label">SMTP Server</label>
                                        <input
                                            type="text"
                                            id="smtpServer"
                                            name="smtpServer"
                                            className="form-control"
                                            value={generalSetup.smtpServer}
                                            onChange={handleChange}
                                            placeholder="Enter SMTP Server"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="smtpMailPort" className="form-label">SMTP Mail Port</label>
                                        <input
                                            type="number"
                                            id="smtpMailPort"
                                            name="smtpMailPort"
                                            className="form-control"
                                            value={generalSetup.smtpMailPort}
                                            onChange={handleChange}
                                            placeholder="Enter SMTP Mail Port"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="smtpTimeout" className="form-label">SMTP Timeout</label>
                                        <input
                                            type="number"
                                            id="smtpTimeout"
                                            name="smtpTimeout"
                                            className="form-control"
                                            value={generalSetup.smtpTimeout}
                                            onChange={handleChange}
                                            placeholder="Enter SMTP Timeout"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="sslRequired" className="form-label">SSL Required</label>
                                        <input
                                            type="checkbox"
                                            id="sslRequired"
                                            name="sslRequired"
                                            checked={generalSetup.sslRequired}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">
                                            Update General Setup
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditGeneralSetup;
